import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ChangeControlAuditService } from '../services/change-control-audit.service';
import { AuditTrialDetails } from '../../../../../shared/models/audits/audit-trial-details';
import { ChangeControlTransitionDetails } from '../models/change-control-transition-details';
import { ChangeControlLifeCycle } from '../models/change-control-life-cycle';
import { ChangeControlPersistenceService } from '../../../services/change-control-persistence.service';
import { catchError, throwError } from 'rxjs';
import { SharedConstants } from '../../../../../shared/constants/shared-constants';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-change-control-audit-trial',
  templateUrl: './change-control-audit-trial.component.html',
  styleUrls: ['./change-control-audit-trial.component.scss'],
})
export class ChangeControlAuditTrialComponent implements OnInit, OnDestroy {
  @Input() number: string = '';
  auditAttributeDetailsOfTransaction!: AuditTrialDetails;
  changeControlTransitionDetails!: ChangeControlTransitionDetails;
  changeControlLifeCycleDetails: ChangeControlLifeCycle[] = [];
  changeControlAuditSummaryDetails: AuditTrialDetails[] = [];
  showLoader: boolean = false;
  ischangeControlAuditDetailsDataLoaded = false;
  constructor(
    private changeControlAuditService: ChangeControlAuditService,
    private changeControlPersistenceService: ChangeControlPersistenceService,
    private changeDetectorRef: ChangeDetectorRef,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.changeControlPersistenceService.isChangeControlUpdated$.subscribe(
      (isRefreshRequired) => {
        if (isRefreshRequired) {
          setTimeout(() => {
          this.loadAuditDetails();
          }, 2000);
        }
      }
    );
    this.loadAuditDetails();
  }
  loadAuditDetails = () => {
    this.ischangeControlAuditDetailsDataLoaded = false;
    this.showLoader = true;
    this.changeControlAuditService
      .getChangeControlTransitionDetails(this.number)
      .pipe(
        catchError((err) => {
          this.showLoader = false;
          this.messageService.add({
            severity: SharedConstants.Severity_Error,
            summary: SharedConstants.Audit_Fail_Error_Message,
            sticky: true
          });
          return throwError(() => err);
        })
      )
      .subscribe((changeControlTransitionDetails) => {
        this.changeControlTransitionDetails = {...changeControlTransitionDetails};
        this.changeControlLifeCycleDetails = this.changeControlTransitionDetails.changeControlLifeCycleDetails;
        this.changeControlAuditSummaryDetails = this.changeControlTransitionDetails.changeControlAuditTrialDetails;
        this.auditAttributeDetailsOfTransaction = this.changeControlTransitionDetails.changeControlAuditTrialDetails[0];
        this.changeDetectorRef.detectChanges();
        this.ischangeControlAuditDetailsDataLoaded = true;
        this.notifyMissingAttributesIfAny();
        this.showLoader = false;
      });
  };
  showAuditItemDetails = (auditAttributeDetails: any) => {
    this.auditAttributeDetailsOfTransaction = auditAttributeDetails;
  };

  ngOnDestroy = () => {
    this.changeControlPersistenceService.isChangeControlUpdated$.unsubscribe();
  };

  private hasMissingAttributes(): boolean {
    const summary = this.changeControlAuditSummaryDetails;
    return !!summary?.some(d => d?.attributeDetails?.some(a => a?.isAttributeValueMissing));
  }
  private notifyMissingAttributesIfAny(): void {
    if (this.hasMissingAttributes()) {
      this.messageService.add({
        severity: SharedConstants.Severity_Warning,
        summary: SharedConstants.AuditTrail_AttributeMissing_Message,
        life: 20000,
      });
    }
  }
}
